import styled from 'styled-components';

export const Wrapper = styled.div``;

export const UploadFilesWrapper = styled.div``;

export const ButtonWrapper = styled.div`
	justify-content: flex-end;
	display: flex;
	margin-top: 2rem;
`;

export const Details = styled.p`
    margin: 1rem 0;
    font-size: 1.7rem;
    font-weight: bold;
`;
